import { z } from "zod";
import { ValidationMethods } from "../utility/validationMethods";
export var discountsSectionSchema = z.object({
    manualCode: z
        .string()
        .trim()
        .min(1, "Please enter only letters, numbers, and standard symbols.")
        .refine(function (value) { return ValidationMethods.isNotEmoji(value); }, "Please enter only letters, numbers, and standard symbols.")
        .refine(function (value) { return ValidationMethods.isAsciiPrintableWithoutSpaces(value); }, "Please enter only letters, numbers, and standard symbols."),
});
